export default __webpack_public_path__ + "static/media/facebook-square-brands.0be4b9b7.svg";